import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  ViewChildren,
  QueryList,
  ElementRef,
} from '@angular/core';
import { TranslateService } from 'src/app/services/translate.service';
import { ApiService } from 'src/app/services/api.service';
import { GridSettings, GridColumn, Header } from './GridSettings';
import { PaginatedResult } from 'src/app/shared/grid/paginate.model';
import { ModalContainerComponent } from '../modal-container/modal-container.component';
import { IconService } from '../../services/icon.service';
import { SimpleChanges } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  faQuestionCircle,
  faFilter,
  faPlus,
  faFileExcel,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { Observable, Subscription } from 'rxjs';
import { ContractService } from 'src/app/services/contract.service';
import { PendingReturnService } from 'src/app/services/pending-return.service';
import {
  IPaginatedService,
  IPaginatedServiceParamters,
} from 'src/app/core/models/ITable';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.css'],
})
export class GridComponent<T> implements OnInit, AfterViewInit {
  //Childs
  @ViewChild(ModalContainerComponent) modalContainer: ModalContainerComponent;
  @ViewChildren('checkbox') checkboxes: QueryList<ElementRef>;

  // Output
  @Output() deleteAction = new EventEmitter();
  @Output() addEventEmmiter = new EventEmitter();
  @Output() selectElementEvent = new EventEmitter();

  // Inputs
  @Input() tableService: IPaginatedService;
  @Input() search: any;
  @Input() actions: any;
  @Input() dataType: T;
  @Input() formTemplate?: any;
  @Input() query: string = 'CreatedOrNot=true';
  @Input() id: number = 0;
  @Input() buttonForCreation?: boolean = true;
  @Input() isParentPage?: boolean = true;
  @Input() size: number = 1; // 1 small, 2 medium, 3 large
  @Input() cancelFormButton: boolean = false; // 1 small, 2 medium, 3 large
  @Input() settings: GridSettings;
  @Input() _refreshGrid: Observable<boolean>;
  @Input() itemsPerPage: number = 10;
  @Input() customEmptyMessage: string; // Mensaje personalizado en caso de tabla vacia

  // Properties
  iconPlus = faPlus;
  totalPages: number;
  totalItems: number;
  headers: Header[] = [];
  tableData: any[];
  renderData: any[] = [];
  rawData: any[] = [];
  isLoaded = false;
  personType: string = 'IsAddress';
  currentSelectedElement: any;
  currentSelectedElementsArray: any[] = [];
  currentSelectedElementsArrayIndexes: string[] = [];
  toggleFilters: boolean = false;
  appliedFilters: boolean = false;
  buttonText: string = 'Mostrar';
  hardFilt: string = '';
  paginatedArguments: IPaginatedServiceParamters = {
    query: this.query,
    pageNumber: 1,
    pageSize: this.itemsPerPage,
    id: this.id,
  };
  paginatedData: {
    firstItem: number;
    lastItem: number;
    currentPage: number;
  };

  keys: string[];
  headerData: any[];
  tableWidth: string;
  columnsWidth: string[] = [];
  urlData: any = [];
  title: string;

  loadingCSV = false;
  iconExcel = faFileExcel;
  
  // Variables para controlar dropdowns
  showContractDropdown = false;
  showReturnsDropdown = false;
  showPropertyDropdown = false; // Nueva variable para el dropdown de propiedad
  currentPropertyData: any = null; // Datos de la propiedad actual

  iconQuestion = faQuestionCircle;
  iconFilter = faFilter;
  iconTimesChip = faTimes;

  /** Etiquetas de filtros activos (URL) para mostrar aunque el panel esté cerrado */
  activeFilterChips: { key: string; label: string; displayValue: string }[] = [];

  configUrl = 'assets/config.json';
  subscriptions = new Subscription();

  constructor(
    public translateService: TranslateService,
    public apiService: ApiService,
    public iconService: IconService,
    public contractService: ContractService,
    public pendingReturnService: PendingReturnService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastService: ToastService,
  ) {
    this.headers = [];
    this.tableData = [];
    this.renderData = [];
  }

  ngOnInit(): void {
    this.tableWidth = this.settings.tableWidth + 'px';
    this.subscriptions.add(
      this.activatedRoute.queryParams.subscribe((params) => {
        var objectKeys = Object.keys(params);

        if (
          (objectKeys.indexOf('ContractId') < 0 && objectKeys.length > 0) ||
          objectKeys.length > 1
        ) {
          // this.toggleFilters = true;
        }

        this.appliedFilters = objectKeys.length > 0 ? true : false;
        this.toggleFilters = false;
        this.buttonText = 'Mostrar';

        this.loadDefaultPagParameterValues();

        objectKeys.forEach((key) => {
          if (
            params[key] != null &&
            this.paginatedArguments.query?.split('=')[0] != key
          ) {
            this.paginatedArguments[key] = params[key];
          }
        });
        this.refreshActiveFilterChips(params);
        this.getElements();
      }),
    );
    this.subscriptions.add(
      this._refreshGrid.subscribe((result) => {
        this.getElements();
      }),
    );
  }

  ngAfterViewInit(): void {
    // Inicializar dropdowns de Bootstrap 5
    this.initializeDropdowns();
    
    // Agregar listener para cerrar dropdowns al hacer click fuera
    document.addEventListener('click', (event) => {
      const target = event.target as HTMLElement;
      if (!target.closest('.dropdown')) {
        this.showContractDropdown = false;
        this.showReturnsDropdown = false;
        this.showPropertyDropdown = false;
      }
    });
  }

  private initializeDropdowns(): void {
    // Esperar un poco para que el DOM esté completamente renderizado
    setTimeout(() => {
      const dropdownElements = document.querySelectorAll('[data-bs-toggle="dropdown"]');
      dropdownElements.forEach(element => {
        // Verificar si ya está inicializado
        if (!element.getAttribute('data-bs-initialized')) {
          // Inicializar el dropdown manualmente
          const dropdown = new (window as any).bootstrap.Dropdown(element);
          element.setAttribute('data-bs-initialized', 'true');
        }
      });
    }, 100);
  }

  toggleContractDropdown(): void {
    this.showContractDropdown = !this.showContractDropdown;
    this.showReturnsDropdown = false; // Cerrar el otro dropdown
  }

  toggleReturnsDropdown(): void {
    this.showReturnsDropdown = !this.showReturnsDropdown;
    this.showContractDropdown = false; // Cerrar el otro dropdown
  }

  togglePropertyDropdown(data: any): void {
    this.currentPropertyData = data;
    this.showPropertyDropdown = !this.showPropertyDropdown;
    this.showContractDropdown = false;
    this.showReturnsDropdown = false;
  }

  viewContractFromProperty(): void {
    if (this.currentPropertyData) {
      // Lógica para ir al contrato
      this.router.navigateByUrl(`/contracts/${this.currentPropertyData.id}/detail`);
    }
    this.showPropertyDropdown = false;
  }

  viewPropertyFromProperty(): void {
    if (this.currentPropertyData) {
      // Extraer el propertyId del contrato
      const propertyId = this.currentPropertyData.property?.id;
      if (propertyId) {
        this.router.navigateByUrl(`/properties/${propertyId}`);
      }
    }
    this.showPropertyDropdown = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.id?.currentValue != changes.id?.previousValue) {
      this.refresh();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private refreshActiveFilterChips(params: Params): void {
    const chips: { key: string; label: string; displayValue: string }[] = [];

    (this.settings?.filter || []).forEach((f) => {
      const v = params[f.name];
      if (v !== undefined && v !== null && String(v).trim() !== '') {
        chips.push({
          key: f.name,
          label: f.filterName,
          displayValue: String(v),
        });
      }
    });

    if (this.settings?.orderBy && params['OrderBy']) {
      const ob = this.settings.orderBy.find((o) => o.name === params['OrderBy']);
      if (ob) {
        chips.push({
          key: 'OrderBy',
          label: 'Orden',
          displayValue: `${ob.filterName} (asc.)`,
        });
      }
    }
    if (this.settings?.orderBy && params['OrderByDescending']) {
      const ob = this.settings.orderBy.find(
        (o) => o.name === params['OrderByDescending'],
      );
      if (ob) {
        chips.push({
          key: 'OrderByDescending',
          label: 'Orden',
          displayValue: `${ob.filterName} (desc.)`,
        });
      }
    }

    this.activeFilterChips = chips;
  }

  removeFilterChip(chip: { key: string }): void {
    if (chip.key === 'OrderBy' || chip.key === 'OrderByDescending') {
      this.router.navigate([], {
        queryParams: { OrderBy: null, OrderByDescending: null },
        queryParamsHandling: 'merge',
      });
    } else {
      this.router.navigate([], {
        queryParams: { [chip.key]: null },
        queryParamsHandling: 'merge',
      });
    }
  }

  // Internal functions
  getElements() {
    this.isLoaded = false;

    let urlString = location.href;
    let url = new URL(urlString);
    let params = new URLSearchParams(url.search);
    this.title = params.get('Title');
    this.subscriptions.add(

 
      
      this.tableService.getAllPaginated(this.paginatedArguments).subscribe(
        (data: PaginatedResult<T[]>) => {
          this.rawData = JSON.parse(JSON.stringify(data.result));
          this.parseDataToRender(data);
          this.isLoaded = true;
        },
        (error) => {
          if (this.paginatedArguments.pageNumber != 1) {
            this.paginatedArguments.pageNumber = 1;
            this.getElements();
          } else {
            this.rawData = [];
            this.tableData = [];
            this.renderData = [];
            this.isLoaded = true;
          }
        },
      ),
    );
    
    // Reinicializar dropdowns después de cargar datos
    setTimeout(() => {
      this.initializeDropdowns();
    }, 200);
  }

  private parseDataToRender(data: PaginatedResult<T[]>) {
    this.headers = [];
    this.renderData = [];
    this.tableData = [];
    let i = 0;
    let x = 0;
    data.result.forEach((row: T) => {
      let j = 0;
      const newRow = {};
      const newUrlFun = {};
      this.settings.columns.forEach((column: GridColumn) => {
        newRow[j] = column.function
          ? column.function(row[column.key])
          : row[column.key];
        j++;
      });
      this.tableData.push(row);
      this.renderData.push(newRow);
      i++;
    });
    this.settings.columns.forEach((column: GridColumn) => {
      // Add headers
      if (column.columnSize) {
        this.headers[x] = {
          title: column.title,
          width: column.columnSize + '%',
        };
      } else {
        this.headers[x] = {
          title: column.title,
          width: null,
        };
      }
      x++;
    });
    this.totalItems = data.pagination?.totalItems || 0;
    this.totalPages = data.pagination?.totalPages || 0;
    this.paginatedData = {
      firstItem:
        (this.paginatedArguments.pageNumber - 1) *
          this.paginatedArguments.pageSize +
        1,
      lastItem: 0,
      currentPage: this.paginatedArguments.pageNumber,
    };
    this.paginatedData.lastItem =
      this.paginatedData.currentPage == this.totalPages
        ? this.totalItems
        : this.itemsPerPage * this.paginatedData.currentPage;
  }

  translate(text: string): string {
    return this.translateService.translate(text);
  }

  pageChanged(event) {
    this.paginatedArguments.pageNumber = event;
    this.getElements();
  }

  deleteRow(value) {
    this.deleteAction.emit(value);
  }

  refresh() {
    this.modalContainer?.closeModal();
    this.getElements();
  }

  addButton() {
    this.addEventEmmiter.emit();
  }

  addEvent() {
    if (this.formTemplate) {
      this.modalContainer.openModal(this.formTemplate);
    }
  }

  /* SEARCH */

  setResults(data: any) {
    this.paginatedArguments.pageNumber = 1;
    let params = {
      ContractId: data.id,
    };
    this.router.navigate([], {
      queryParams: params,
      queryParamsHandling: 'merge',
    });
  }

  clearSearch() {
    this.paginatedArguments.pageNumber = 1;
    let urlString = location.href;
    let url = new URL(urlString);
    let params = new URLSearchParams(url.search);
    params.delete('ContractId');
    let index = urlString.indexOf('/', 10);
    this.router.navigateByUrl(
      `${urlString.split('?')[0].slice(index)}${
        params.toString() ? '?' + params.toString() : ''
      }`,
    );
    this.getElements();
  }

  returnSelectElement(row, isChecked, index) {
    var returnElement = {
      data: this.tableData[index],
      status: isChecked.checked,
      index: index,
      page: this.paginatedArguments.pageNumber,
    };
    this.currentSelectedElement = returnElement;
    this.selectElementEvent.emit(returnElement);
  }

  returnSelectedElements(row, isChecked, index) {
    var returnElement = {
      data: this.tableData[index],
      status: isChecked.checked,
      index: index,
      page: this.paginatedArguments.pageNumber,
    };

    if (isChecked.checked) {
      this.currentSelectedElementsArray.push(returnElement);
      this.currentSelectedElementsArrayIndexes.push(
        `${this.paginatedArguments.pageNumber}${index}`,
      );
    } else {
      var foundElementIndex = undefined;
      this.currentSelectedElementsArray.forEach((element, ind) => {
        if (
          element.page == this.paginatedArguments.pageNumber &&
          element.index == index
        ) {
          foundElementIndex = ind;
        }
      });
      if (this.currentSelectedElementsArray.length == 1) {
        this.currentSelectedElementsArray = [];
      } else {
        foundElementIndex != undefined
          ? this.currentSelectedElementsArray.splice(foundElementIndex, 1)
          : false;
      }
      var indexArrayDeleteIndex =
        this.currentSelectedElementsArrayIndexes.indexOf(
          `${this.paginatedArguments.pageNumber}${index}`,
        );
      this.currentSelectedElementsArrayIndexes.length == 1
        ? (this.currentSelectedElementsArrayIndexes = [])
        : this.currentSelectedElementsArrayIndexes.splice(
            indexArrayDeleteIndex,
            1,
          );
    }
    this.selectElementEvent.emit(this.currentSelectedElementsArray);
  }

  isSelected(index): boolean {
    return this.currentSelectedElementsArrayIndexes.includes(
      `${this.paginatedArguments.pageNumber}${index}`,
    );
  }

  turnOnFilters() {
    this.toggleFilters = !this.toggleFilters;
    if (this.toggleFilters) {
      this.buttonText = 'Ocultar';
    } else {
      this.buttonText = 'Mostrar';
    }
  }

  checkArray(row): boolean {
    return Array.isArray(row);
  }

  loadDefaultPagParameterValues() {
    var number = this.paginatedArguments.pageNumber;
    this.paginatedArguments = {
      query:
        this.query + this.settings.hardcodedFilter
          ? this.settings.hardcodedFilter
          : '',
      pageNumber: 1,
      pageSize: this.itemsPerPage,
      id: this.id,
      period: this.settings.period,
    };
  }

  unCheck() {
    this.currentSelectedElement = undefined;
    this.currentSelectedElementsArray = [];
    this.currentSelectedElementsArrayIndexes = [];
    this.checkboxes.forEach((checkbox) => {
      checkbox.nativeElement.checked = false;
    });
  }

  togglePages(event) {
    this.router.navigateByUrl(event);
  }

  changePageSize(event) {
    this.itemsPerPage = event.target.value;
    this.paginatedArguments.pageSize = event.target.value;
    this.refresh();
  }

  footerMsg(title) {
    title = title ? `${title} del ` : '';
    return `Mostrando ${title}${this.paginatedData.firstItem} al ${this.paginatedData.lastItem} de ${this.totalItems} registros.`;
  }

  downloadCSV(event?: Event) {
    if (event) {
      event.preventDefault();
    }
    
    this.showContractDropdown = false; // Cerrar dropdown
    this.loadingCSV = true;
    console.log('Descargando CSV con filtros actuales...');
    this.toastService.showToast(
      'info',
      'Descargando CSV, el proceso puede tomar unos momentos...',
    );
    
    // Usar el servicio correcto según el contexto
    if (this.tableService && typeof this.tableService.downloadCSV === 'function') {
      this.tableService.downloadCSV(this.paginatedArguments).subscribe(
        (res: Blob) => {
          const blob = new Blob([res], { type: 'text/csv' });

          const url = window.URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = url;
          a.download = 'Datos_' + new Date().toISOString() + '.csv';

          a.click();

          window.URL.revokeObjectURL(url);
          this.loadingCSV = false;

          this.toastService.showToast('success', 'Descarga Exitosa');
        },
        (error) => {
          this.toastService.showToast(
            'error',
            'Error al descargar el archivo CSV',
          );
          this.loadingCSV = false;
          console.error('Error al descargar el archivo CSV', error);
        },
      );
    } else {
      this.toastService.showToast(
        'error',
        'Funcionalidad de descarga no disponible para este módulo',
      );
      this.loadingCSV = false;
    }
  }

  downloadExcel(event?: Event) {
    if (event) {
      event.preventDefault();
    }
    
    this.showContractDropdown = false; // Cerrar dropdown
    this.loadingCSV = true;
    console.log('Descargando Excel con filtros actuales...');
    this.toastService.showToast(
      'info',
      'Descargando Excel, el proceso puede tomar unos momentos...',
    );
    
    // Usar el servicio correcto según el contexto
    if (this.tableService && typeof this.tableService.downloadExcel === 'function') {
      this.tableService.downloadExcel(this.paginatedArguments).subscribe(
        (res: Blob) => {
          const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

          const url = window.URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = url;
          a.download = 'Datos_' + new Date().toISOString() + '.xlsx';

          a.click();

          window.URL.revokeObjectURL(url);
          this.loadingCSV = false;

          this.toastService.showToast('success', 'Descarga Exitosa');
        },
        (error) => {
          this.toastService.showToast(
            'error',
            'Error al descargar el archivo Excel',
          );
          this.loadingCSV = false;
          console.error('Error al descargar el archivo Excel', error);
        },
      );
    } else {
      this.toastService.showToast(
        'error',
        'Funcionalidad de descarga no disponible para este módulo',
      );
      this.loadingCSV = false;
    }
  }

  downloadReturnsCSV(type: 'view' | 'all') {
    this.loadingCSV = true;
    console.log(`Descargando CSV de liquidaciones: ${type === 'view' ? 'Vista actual' : 'Todo el contenido'}`);
    
    let params;
    if (type === 'view') {
      params = this.paginatedArguments;
    } else {
      // Para "Todo", mantener los filtros básicos pero con pageSize grande
      params = { ...this.paginatedArguments, pageSize: 100000, pageNumber: 1 };
    }
    
    (this.tableService as any).downloadReturnsCSV(params).subscribe(
      (res: Blob) => {
        const blob = new Blob([res], { type: 'text/csv' });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        
        const today = new Date();
        const day = today.getDate().toString().padStart(2, '0');
        const month = (today.getMonth() + 1).toString().padStart(2, '0');
        const year = today.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;
        
        // Determinar el tipo de liquidación basado en la URL actual
        const currentUrl = window.location.pathname;
        const liquidacionType = currentUrl.includes('historical-returns') ? 'Saldadas' : 'Pendientes';
        
        a.download = `Liquidaciones_${type === 'view' ? 'Vista' : 'Completo'}_${liquidacionType}_${formattedDate}.csv`;

        a.click();

        window.URL.revokeObjectURL(url);
        this.loadingCSV = false;

        this.toastService.showToast('success', 'Descarga Exitosa');
      },
      (error) => {
        this.toastService.showToast(
          'error',
          'Error al descargar el archivo CSV',
        );
        this.loadingCSV = false;
        console.error('Error al descargar el archivo CSV', error);
      },
    );
  }

  downloadReturnsExcel(type: 'view' | 'all') {
    this.loadingCSV = true;
    console.log(`Descargando Excel de liquidaciones: ${type === 'view' ? 'Vista actual' : 'Todo el contenido'}`);
    
    let params;
    if (type === 'view') {
      params = this.paginatedArguments;
    } else {
      // Para "Todo", mantener los filtros básicos pero con pageSize grande
      params = { ...this.paginatedArguments, pageSize: 100000, pageNumber: 1 };
    }
    
    (this.tableService as any).downloadReturnsExcel(params).subscribe(
      (res: Blob) => {
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        
        const today = new Date();
        const day = today.getDate().toString().padStart(2, '0');
        const month = (today.getMonth() + 1).toString().padStart(2, '0');
        const year = today.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;
        
        // Determinar el tipo de liquidación basado en la URL actual
        const currentUrl = window.location.pathname;
        const liquidacionType = currentUrl.includes('historical-returns') ? 'Saldadas' : 'Pendientes';
        
        a.download = `Liquidaciones_${type === 'view' ? 'Vista' : 'Completo'}_${liquidacionType}_${formattedDate}.xlsx`;

        a.click();

        window.URL.revokeObjectURL(url);
        this.loadingCSV = false;

        this.toastService.showToast('success', 'Descarga Exitosa');
      },
      (error) => {
        this.toastService.showToast(
          'error',
          'Error al descargar el archivo Excel',
        );
        this.loadingCSV = false;
        console.error('Error al descargar el archivo Excel', error);
      },
    );
  }

  downloadPaymentsCSV(type: 'view' | 'all') {
    this.loadingCSV = true;
    console.log(`Descargando CSV de pagos: ${type === 'view' ? 'Vista actual' : 'Todo el contenido'}`);
    
    let params;
    if (type === 'view') {
      params = this.paginatedArguments;
    } else {
      // Para "Todo", mantener los filtros básicos pero con pageSize grande
      params = { ...this.paginatedArguments, pageSize: 100000, pageNumber: 1 };
    }
    
    (this.tableService as any).downloadPaymentsCSV(params).subscribe(
      (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        
        const today = new Date();
        const day = today.getDate().toString().padStart(2, '0');
        const month = (today.getMonth() + 1).toString().padStart(2, '0');
        const year = today.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;
        
        a.download = `Pagos_${type === 'view' ? 'Vista' : 'Completo'}_${formattedDate}.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.loadingCSV = false;
        this.toastService.showToast('success', 'Archivo CSV descargado exitosamente');
      },
      (error) => {
        this.loadingCSV = false;
        this.toastService.showToast('error', 'Error al descargar el archivo CSV');
        console.error('Error al descargar el archivo CSV', error);
      }
    );
  }

  downloadPaymentsExcel(type: 'view' | 'all') {
    this.loadingCSV = true;
    console.log(`Descargando Excel de pagos: ${type === 'view' ? 'Vista actual' : 'Todo el contenido'}`);
    
    let params;
    if (type === 'view') {
      params = this.paginatedArguments;
    } else {
      // Para "Todo", mantener los filtros básicos pero con pageSize grande
      params = { ...this.paginatedArguments, pageSize: 100000, pageNumber: 1 };
    }
    
    (this.tableService as any).downloadPaymentsExcel(params).subscribe(
      (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        
        const today = new Date();
        const day = today.getDate().toString().padStart(2, '0');
        const month = (today.getMonth() + 1).toString().padStart(2, '0');
        const year = today.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;
        
        a.download = `Pagos_${type === 'view' ? 'Vista' : 'Completo'}_${formattedDate}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.loadingCSV = false;
        this.toastService.showToast('success', 'Archivo Excel descargado exitosamente');
      },
      (error) => {
        this.loadingCSV = false;
        this.toastService.showToast('error', 'Error al descargar el archivo Excel');
        console.error('Error al descargar el archivo Excel', error);
      }
    );
  }

  downloadContractsCSV(type: 'view' | 'all') {
    this.loadingCSV = true;
    console.log(`Descargando CSV de contratos: ${type === 'view' ? 'Vista actual' : 'Todo el contenido'}`);
    
    let params: any;
    if (type === 'view') {
      params = { ...this.paginatedArguments };
    } else {
      // Para "Todo", mantener los filtros básicos pero con pageSize grande
      params = { ...this.paginatedArguments, pageSize: 100000, pageNumber: 1 };
    }
    
    // Parsear el hardcodedFilter para extraer parámetros como Active
    if (this.settings.hardcodedFilter) {
      const filterParts = this.settings.hardcodedFilter.split('&');
      filterParts.forEach(part => {
        const [key, value] = part.split('=');
        if (key && value !== undefined) {
          // Convertir valores booleanos
          if (value === 'true' || value === 'false') {
            params[key] = value === 'true';
          } else if (!isNaN(Number(value)) && value !== '') {
            params[key] = Number(value);
          } else {
            params[key] = decodeURIComponent(value);
          }
        }
      });
    }
    
    (this.tableService as any).downloadContractsCSV(params).subscribe(
      (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        
        const today = new Date();
        const day = today.getDate().toString().padStart(2, '0');
        const month = (today.getMonth() + 1).toString().padStart(2, '0');
        const year = today.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;
        
        a.download = `Contratos_${type === 'view' ? 'Vista' : 'Completo'}_${formattedDate}.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.loadingCSV = false;
        this.toastService.showToast('success', 'Archivo CSV descargado exitosamente');
      },
      (error) => {
        this.loadingCSV = false;
        this.toastService.showToast('error', 'Error al descargar el archivo CSV');
        console.error('Error al descargar el archivo CSV', error);
      }
    );
  }

  downloadContractsExcel(type: 'view' | 'all') {
    this.loadingCSV = true;
    console.log(`Descargando Excel de contratos: ${type === 'view' ? 'Vista actual' : 'Todo el contenido'}`);
    
    let params: any;
    if (type === 'view') {
      params = { ...this.paginatedArguments };
    } else {
      // Para "Todo", mantener los filtros básicos pero con pageSize grande
      params = { ...this.paginatedArguments, pageSize: 100000, pageNumber: 1 };
    }
    
    // Parsear el hardcodedFilter para extraer parámetros como Active
    if (this.settings.hardcodedFilter) {
      const filterParts = this.settings.hardcodedFilter.split('&');
      filterParts.forEach(part => {
        const [key, value] = part.split('=');
        if (key && value !== undefined) {
          // Convertir valores booleanos
          if (value === 'true' || value === 'false') {
            params[key] = value === 'true';
          } else if (!isNaN(Number(value)) && value !== '') {
            params[key] = Number(value);
          } else {
            params[key] = decodeURIComponent(value);
          }
        }
      });
    }
    
    (this.tableService as any).downloadContractsExcel(params).subscribe(
      (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        
        const today = new Date();
        const day = today.getDate().toString().padStart(2, '0');
        const month = (today.getMonth() + 1).toString().padStart(2, '0');
        const year = today.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;
        
        a.download = `Contratos_${type === 'view' ? 'Vista' : 'Completo'}_${formattedDate}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.loadingCSV = false;
        this.toastService.showToast('success', 'Archivo Excel descargado exitosamente');
      },
      (error) => {
        this.loadingCSV = false;
        this.toastService.showToast('error', 'Error al descargar el archivo Excel');
        console.error('Error al descargar el archivo Excel', error);
      }
    );
  }

  downloadFeesCSV(type: 'view' | 'all') {
    this.loadingCSV = true;
    console.log(`Descargando CSV de honorarios: ${type === 'view' ? 'Vista actual' : 'Todo el contenido'}`);
    
    let params;
    if (type === 'view') {
      params = this.paginatedArguments;
    } else {
      // Para "Todo", mantener los filtros básicos pero con pageSize grande
      params = { ...this.paginatedArguments, pageSize: 100000, pageNumber: 1 };
    }
    
    (this.tableService as any).downloadFeesCSV(params).subscribe(
      (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        
        const today = new Date();
        const day = today.getDate().toString().padStart(2, '0');
        const month = (today.getMonth() + 1).toString().padStart(2, '0');
        const year = today.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;
        
        // Determinar el tipo de honorarios basado en la URL actual
        const currentUrl = window.location.pathname;
        const feesType = currentUrl.includes('historical') ? 'Saldados' : 'Pendientes';
        
        a.download = `Honorarios_${type === 'view' ? 'Vista' : 'Completo'}_${feesType}_${formattedDate}.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.loadingCSV = false;
        this.toastService.showToast('success', 'Archivo CSV descargado exitosamente');
      },
      (error) => {
        this.loadingCSV = false;
        this.toastService.showToast('error', 'Error al descargar el archivo CSV');
        console.error('Error al descargar el archivo CSV', error);
      }
    );
  }

  downloadFeesExcel(type: 'view' | 'all') {
    this.loadingCSV = true;
    console.log(`Descargando Excel de honorarios: ${type === 'view' ? 'Vista actual' : 'Todo el contenido'}`);
    
    let params;
    if (type === 'view') {
      params = this.paginatedArguments;
    } else {
      // Para "Todo", mantener los filtros básicos pero con pageSize grande
      params = { ...this.paginatedArguments, pageSize: 100000, pageNumber: 1 };
    }
    
    (this.tableService as any).downloadFeesExcel(params).subscribe(
      (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        
        const today = new Date();
        const day = today.getDate().toString().padStart(2, '0');
        const month = (today.getMonth() + 1).toString().padStart(2, '0');
        const year = today.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;
        
        // Determinar el tipo de honorarios basado en la URL actual
        const currentUrl = window.location.pathname;
        const feesType = currentUrl.includes('historical') ? 'Saldados' : 'Pendientes';
        
        a.download = `Honorarios_${type === 'view' ? 'Vista' : 'Completo'}_${feesType}_${formattedDate}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.loadingCSV = false;
        this.toastService.showToast('success', 'Archivo Excel descargado exitosamente');
      },
      (error) => {
        this.loadingCSV = false;
        this.toastService.showToast('error', 'Error al descargar el archivo Excel');
        console.error('Error al descargar el archivo Excel', error);
      }
    );
  }

}
